/**
 * Utility functions for GitLab API operations
 */

export const handleApiError = async (response: Response): Promise<never> => {
  const errorData = await response.json().catch(() => ({}));
  const message =
    typeof errorData === 'object' &&
    errorData !== null &&
    'message' in errorData
      ? String(errorData.message)
      : `Error: ${response.statusText}`;
  throw new Error(message);
};
